import { fromFetch } from 'rxjs/fetch';
import { AuthHeaders } from '../../models/auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { ignoreData } from '../../utils/ignore-data';
import { accountsEnvironment } from './accounts-environment';

export function deleteLicense(
  asset: Record<string, string>,
  productId: number
) {
  return fromFetch(
    new Request(`${accountsEnvironment.licenseUrl}/${productId}`, {
      method: 'DELETE',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
      body: JSON.stringify(asset),
    })
  ).pipe(ignoreData());
}
